interface IProps {
    style?: React.CSSProperties
}
const DividerThin = ({ style }: IProps) => {
    return <div style={{ width: '100%', backgroundColor: 'var(--secondarys100)', height: '1px', ...style }} />
}

export { DividerThin }